import React from 'react'; 
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import TextBox from '../Basic/TextBox';
import DatePicker from '../Enhanced/DatePicker';
import util from '../../lib/util';

class ResidentInfo extends React.Component {
    render() {
        const p = this.props;
        const name = this.props.name;
        const isPlus19 = !(p.dob && !util.isPlus19(p.dob));     
 
        return (
            <div>
                <div className="row">
                    <div className="col-sm-4">
                        <TextBox title="First name" id={name + "_firstName"} name={name + "_firstName"} maxLength={40} required disabled={p.disabled} />
                    </div>
                    <div className="col-sm-4">
                        <TextBox title="Last name" id={name + "_lastName"} name={name + "_lastName"} maxLength={40} required disabled={p.disabled} />
                    </div>
                </div>
                <div className="row">
                    <div className="col-sm-4">
                        <DatePicker title="Date of birth" id={name + "_dob"} name={name + "_dob"} required disabled={p.disabled} allowDOBEdit={p.allowDOBEdit}/>
                        {isPlus19 ? null :
                            (<span className="error" style={{ color: 'red' }}>
                                <i className="fa fa-exclamation-circle" /> Age should be over 19 years old.
                            </span>)
                        }
                        <br />
                    </div>
                </div>
            </div>
        );
    }
}
ResidentInfo.propTypes = {
    name: PropTypes.string.isRequired,
    disabled: PropTypes.bool
};
const mapStateToProps = (state, props) => {
    return {
        dob: state.form[props.name + "_dob"]
    };
};
export default connect(mapStateToProps)(ResidentInfo);
export function ResidentInfoValidator(name) {
    return [[name + "_firstName", p => (p[name + "_firstName"]), "First name"],
    [name + "_lastName", p => (p[name + "_lastName"]), "Last name"],
    [name + "_dob", p => (p[name + "_dob"]), "Date of birth"]
    ];
}